export default {
  'brand.name': 'USFans Spreadsheet',
  'nav.home': 'Accueil',
  'nav.guides': 'Guides',
  'nav.buyingGuide': 'Guide d\'achat',
  'nav.review': 'Avis',
  'nav.shipping': 'Expédition',
  'nav.safety': 'Sécurité',
  'nav.faq': 'FAQ',
  'nav.buyNow': 'Acheter maintenant',
  'lang.label': 'Langue',
  'lang.en': 'English',
  'lang.pl': 'Polski',
  'lang.es': 'Español',
  'lang.fr': 'Français',

  'footer.tagline': 'Une ressource d\'information indépendante sur USFans Spreadsheet.',
  'footer.disclaimer': 'Ce site est une ressource d\'information indépendante. Il n\'est pas officiellement affilié à USFans ni soutenu par lui, sauf indication explicite.',
  'footer.col.explore': 'Explorer',
  'footer.col.guides': 'Guides',
  'footer.col.legal': 'Mentions légales',
  'footer.about': 'À propos',
  'footer.contact': 'Contact',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'footer.disclaimerLink': 'Avertissement',
  'footer.copyright': '© 2026 USFans Spreadsheet. Tous droits réservés.',

  'common.readMore': 'Lire la suite',
  'common.backHome': 'Retour à l\'accueil',
  'common.explore': 'Explorer USFans Spreadsheet',
};